import watermarkBackground from "../assets/images/watermarks/image-watermark-bg.png";
import imgBottomLeft from "../assets/images/watermarks/image-watermark-bottom-left-corner.png";
import imgBottomRight from "../assets/images/watermarks/image-watermark-bottom-right-corner.png";
import imgRandom from "../assets/images/watermarks/image-watermark-random.gif";
import imgUpperLeft from "../assets/images/watermarks/image-watermark-upper-left-corner.png";
import imgUpperRight from "../assets/images/watermarks/image-watermark-upper-right-corner.png";
import userIdBottomLeft from "../assets/images/watermarks/user-id-bottom-left-corner.png";
import userIdBottomRight from "../assets/images/watermarks/user-id-bottom-right-corner.png";
import userIdRandom from "../assets/images/watermarks/user-id-random.gif";
import userIdUpperLeft from "../assets/images/watermarks/user-id-upper-left-corner.png";
import userIdUpperRight from "../assets/images/watermarks/user-id-upper-right-corner.png";
import { WatermarkType, WatermarkPosition } from "../types";

export const watermarkImgsMap: Record<string, any> = {
  [`${WatermarkType.IMAGE}-${WatermarkPosition.BOTTOM_RIGHT}`]: imgBottomRight,
  [`${WatermarkType.IMAGE}-${WatermarkPosition.BOTTOM_LEFT}`]: imgBottomLeft,
  [`${WatermarkType.IMAGE}-${WatermarkPosition.UPPER_RIGHT}`]: imgUpperRight,
  [`${WatermarkType.IMAGE}-${WatermarkPosition.UPPER_LEFT}`]: imgUpperLeft,
  [`${WatermarkType.IMAGE}-${WatermarkPosition.RANDOM}`]: imgRandom,
  [`${WatermarkType.USER_ID}-${WatermarkPosition.BOTTOM_RIGHT}`]: userIdBottomRight,
  [`${WatermarkType.USER_ID}-${WatermarkPosition.BOTTOM_LEFT}`]: userIdBottomLeft,
  [`${WatermarkType.USER_ID}-${WatermarkPosition.UPPER_RIGHT}`]: userIdUpperRight,
  [`${WatermarkType.USER_ID}-${WatermarkPosition.UPPER_LEFT}`]: userIdUpperLeft,
  [`${WatermarkType.USER_ID}-${WatermarkPosition.RANDOM}`]: userIdRandom,
};

export interface PreviewInfo {
  watermarkUrl: string;
  type: string;
  position: string;
}

export const getWatermarkPreviewImg = ({ watermarkUrl = "", type, position }: PreviewInfo): string => {
  if (watermarkUrl && position !== WatermarkPosition.RANDOM) {
    return watermarkBackground;
  }
  return watermarkImgsMap[`${type}-${position}`];
};
